import React, { createContext, ReactNode, useState } from 'react';

interface AppContextProviderProps {
  children: ReactNode;
}

type SnackbarTypes = 'success' | 'error' | 'warning';

interface Snackbar {
  isSnackbarOpen: boolean;
  message?: string | undefined;
  type?: SnackbarTypes;
}

interface AppContextProps {
  isSidebarOpen: boolean;
  toggleSideBar: () => void;
}

const defaultAppContext: AppContextProps = {
  isSidebarOpen: false,
  toggleSideBar: () => ({}),
};

const AppContext = createContext(defaultAppContext);

const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
}: {
  children: ReactNode;
}) => {
  const sidebarInitialState = true;
  const [isSidebarOpen, setIsSidebarOpen] = useState(sidebarInitialState);
  const toggleSideBar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <AppContext.Provider
      value={{
        isSidebarOpen,
        toggleSideBar,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContextProvider, AppContext };
export type { Snackbar };
